import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  height: 25px;
  align-items: center;
  justify-content: center;

  border-radius: 10px;
  background: ${(props) =>
    props.theme.title === 'light'
      ? props.theme.colors.lightgrey
      : props.theme.colors.darker};
  margin: ${(props) => props.margin && '0 10px'};
  filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.3));
`;

export const Overlay = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: transparent;
  z-index: 1000;
`;

export const SelectedOption = styled.h3`
  color: ${(props) =>
    props.selected ? props.theme.colors.darkblue : props.theme.colors.label};
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  margin: 0 auto;
  padding-right: 3px;
  ${(props) =>
    props.selectedColor && props.selected && `color: ${props.selectedColor}`}
`;

export const OptionWrapper = styled.div`
  color: ${(props) => props.theme.colors.darkblue};
  background: ${(props) =>
    props.theme.title === 'light'
      ? props.theme.colors.white
      : props.theme.colors.darker};
  cursor: pointer;
  line-height: 30px;
  transition: all 270ms;
  :hover {
    background: ${(props) => props.theme.colors.darkblue};
    color: ${(props) => props.theme.colors.white};
  }
`;

export const ArrowDown = styled.div`
  width: 8px;
  height: 8px;
  border: 0px solid ${(props) => props.theme.colors.darkblue};
  border-right-width: 1px;
  border-bottom-width: 1px;
  transform: rotate(45deg);
  margin: 0 auto 6px auto;
`;

export const FloatingContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100px;
  height: 100px;
  background: red;
  top: ${(props) => props.position.top};
  bottom: ${(props) => props.position.bottom};
  right: ${(props) => props.position.right};
  left: ${(props) => props.position.left};
`;

export const ImageWrapper = styled.div`
  display: flex;
  width: 65px;
  height: 32px;
  align-items: center;
  justify-content: flex-start;
  border-radius: 10px;
  background: ${(props) =>
    props.theme.title === 'light'
      ? props.status === 'resolvido'
        ? props.theme.colors.green
        : props.status === 'resolvendo'
        ? props.theme.colors.disabled
        : props.theme.colors.white
      : props.status === 'resolvido'
      ? props.theme.colors.green
      : props.status === 'resolvendo'
      ? props.theme.colors.disabled
      : 'transparent'};
`;

export const Icon = styled.img`
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  margin: ${(props) => props.margin || '0 10px'};
  border-radius: 50%;
`;
